import { useEffect } from 'react';
import { POS_Z_CLASS } from '../../utils/posZLayers';

/**
 * Overlay POS dismissible (clic extérieur + Échap) — usage ciblé parcours caisse / restaurant.
 */
export default function PosModalShell({
  open,
  onRequestClose,
  dismissOnBackdrop = true,
  allowEscape = true,
  zClass = POS_Z_CLASS.modalBackdrop,
  className = '',
  panelClassName = '',
  panelTestId,
  children,
  'aria-labelledby': ariaLabelledby,
}) {
  useEffect(() => {
    if (!open || !allowEscape || !onRequestClose) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        onRequestClose();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, allowEscape, onRequestClose]);

  if (!open) return null;

  const handleBackdrop = () => {
    if (dismissOnBackdrop && onRequestClose) onRequestClose();
  };

  return (
    <div
      className={`fixed inset-0 ${zClass} flex items-end sm:items-center justify-center bg-black/40 p-4 pb-[max(1rem,env(safe-area-inset-bottom))] pt-[max(1rem,env(safe-area-inset-top))] ${className}`}
      role="presentation"
      onClick={handleBackdrop}
      data-testid="pos-modal-backdrop"
    >
      <div
        className={`flex w-full max-w-lg max-h-[min(92dvh,calc(100dvh-2rem))] flex-col overflow-hidden rounded-2xl bg-white shadow-xl ${panelClassName}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby={ariaLabelledby}
        onClick={(e) => e.stopPropagation()}
        data-testid={panelTestId}
      >
        {children}
      </div>
    </div>
  );
}
